// extracted by mini-css-extract-plugin
export default {"wrapper":"Wi-z","reviewFormSuccess":"Xi-z","header":"Yi-z","message":"Zi-z","paragraph":"_i-z","lottieContainer":"aj-z"};